import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var warned = {};
export default function (valid, component, message) {
  if (process.env.NODE_ENV !== 'production' && valid && !warned[message]) {
    var _context;

    warned[message] = true;
    console.warn(_concatInstanceProperty(_context = "Warning: [kdesign]-".concat(component, ": ")).call(_context, message));
  }
}